"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validations_1 = require("../../utils/validations");

var ValidationError_1 = __importDefault(require("../../errors/ValidationError"));

var StreamMessage_1 = __importDefault(require("./StreamMessage"));

var GroupKeyMessage = /*#__PURE__*/function () {
  function GroupKeyMessage(streamId, messageType) {
    _classCallCheck(this, GroupKeyMessage);

    (0, validations_1.validateIsString)('streamId', streamId);
    this.streamId = streamId;
    StreamMessage_1.default.validateMessageType(messageType);
    this.messageType = messageType;
  }

  _createClass(GroupKeyMessage, [{
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }, {
    key: "toStreamMessage",
    value: function toStreamMessage(messageId, prevMsgRef) {
      return new StreamMessage_1.default({
        messageId: messageId,
        prevMsgRef: prevMsgRef,
        content: this.serialize(),
        messageType: this.messageType
      });
    }
  }], [{
    key: "deserialize",
    value: function deserialize(serialized, messageType) {
      if (!GroupKeyMessage.classByMessageType[messageType]) {
        throw new ValidationError_1.default("Unknown MessageType: ".concat(messageType));
      }

      return GroupKeyMessage.classByMessageType[messageType].fromArray(JSON.parse(serialized));
    }
  }, {
    key: "fromStreamMessage",
    value: function fromStreamMessage(streamMessage) {
      return GroupKeyMessage.deserialize(streamMessage.getSerializedContent(), streamMessage.messageType);
    }
  }, {
    key: "fromArray",
    value: function fromArray(_arr) {
      // typescript doesn't support abstract static so have to do this
      throw new Error('must be overridden');
    }
  }]);

  return GroupKeyMessage;
}();

exports.default = GroupKeyMessage; // messageType -> class mapping

GroupKeyMessage.classByMessageType = {};